import React from "react"
import ThinButton from "@components/common/thin-button/ThinButton"

import { Props } from "./GermanyCta.interface"
import * as s from "./GermanyCta.module.scss"

export const GermanyCta = ({ data }: Props) => {
  return (
    <div className={`${s.GermanyCta}`}>
      <div className={s.Inner}>
        <div className={s.GermanyCta__row}>
          <div>
            <div className={s.GermanyCta__links}>
              <ThinButton
                to={data.link.url}
                target={data.link.target}
                external={data.link.target === "_blank"}
                backgroundColor="#dd3f40"
                textColor="#fff"
              >
                {data.link.title}
              </ThinButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GermanyCta
